import { fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const LOAD_FORM_MODAL = 'feedback/LOAD_FORM_MODAL'
export const SHOW_FORM_MODAL = 'feedback/SHOW_FORM_MODAL'
export const SAVE_FORM = 'feedback/SAVE_FORM'

// actions
export const loadFeedbackFormModal = ActionHelper.createActionObj(
  LOAD_FORM_MODAL,
)
export const showFeedbackFormModal = ActionHelper.createActionObj(
  SHOW_FORM_MODAL,
)
export const saveFeedbackForm = ActionHelper.createActionObj(SAVE_FORM)

// store
const initialState = fromJS({
  isFormLoaded: false,
  isShowFeedbackFormModal: false,
})

const feedback = handleActions(
  {
    [LOAD_FORM_MODAL]: (state, action) =>
      state.set('isFormLoaded', Boolean(action.payload)),
    [SHOW_FORM_MODAL]: (state, action) =>
      state.set('isShowFeedbackFormModal', Boolean(action.payload)),
  },
  initialState,
)

export default feedback
